module.exports = __webpack_public_path__ + "static/img/pic_03@2x.1b38142c.png";